import React, { useState } from 'react';
import Remarkable from 'react-remarkable';
import { useDispatch, useSelector } from 'react-redux';
import {
  ModalOverlay,
  ModalContent,
  Title,
  TextArea,
  SubmitButton,
} from './QuestInputCSS';
import ObjectActionCreators from '../../../actions';
import AudioRecorder from '../../AudioRecorder/AudioRecorder';
import { Description } from './QuestConfirmationCSS';
import { getAIAsk } from '../../../reducers/objectReducers/action';

const QuestStart = () => {
  const dispatch = useDispatch();
  const [currentInteraction, objId] = useSelector((state) => [
    state.interaction.currentInteraction,
    state.objects.objId,
  ]);

  // Guard clause: Only render for questStart
  if (currentInteraction?.type !== 'questStart') return null;

  const defaultData = {
    question: 'How can I help',
    questionId: -1,
    description: 'type your question',
  };

  const { question, questionId, description } = defaultData;

  // Utiliser le useState pour gérer la réponse localement et éviter les problèmes de focus
  const [localResponse, setLocalResponse] = useState(
    currentInteraction?.response || ''
  );

  // Handle user text input
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setLocalResponse(newValue);

    // Dispatch pour mettre à jour le state global si nécessaire
    dispatch({
      type: 'VOICE_TO_TEXT_INPUT_CLIENT_CHANGED',
      transcription: newValue,
    });
  };

  // Dispatch the response and close the interaction
  const handleSubmit = () => {
    if (localResponse.trim()) {
      dispatch(getAIAsk(localResponse, objId));
      dispatch({
        type: 'INTERACTION_RESPONSE',
        payload: {
          questionId: 'initial',
          response: localResponse,
          isAlternative: false,
        },
      });
      // dispatch({ type: 'INTERACTION_CLOSE' });
    } else {
      alert('Please enter a response before submitting.');
    }
  };

  return (
    <ModalContent>
      <Title>{question}</Title>
      <Description>
        <Remarkable source={description ?? ''} />
      </Description>
      <TextArea
        value={localResponse}
        onChange={handleInputChange}
        placeholder="Type your response here..."
      />
      <AudioRecorder
        onEndRecording={(blob) =>
          dispatch(ObjectActionCreators.voiceToTextInput(blob))
        }
      />
      <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
    </ModalContent>
  );
};

export default QuestStart;
